import { render, staticRenderFns } from "./PedidoCardAdd.vue?vue&type=template&id=66d4c16b"
import script from "./PedidoCardAdd.vue?vue&type=script&lang=js"
export * from "./PedidoCardAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports